module.exports = __webpack_public_path__ + "static/testimonial3-7a6fcf9408ef96055c81bcdf93e329f6.png";